import HTTP from '@/utils/http';

const determineFileName = (headers) => {
    /**
     * The endpoint explicitly adds content-disposition (with filename). We
     * want to extract the filename from the content-disposition headers.
     *
     * Ref: https://stackoverflow.com/a/40940790
     */
    const disposition = headers['content-disposition'];
    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
    /**
     * If we error here, content-disposition or regex is wrong. Shouldn't though!
     */
    if (!matches || !matches[1]) {
        return null;
    }
    return matches[1].replace(/['"]/g, '').replace(/[+]/g, ' ');
};

const determineMimeType = ({ backupFileName, mimeType = '' }) => {
    const extensions = {
        'application/zip': '.zip',
        'application/pdf': '.pdf',
        'text/csv': '.csv',
    };
    const extension = extensions[mimeType.split(';')[0]] || '';
    return `${backupFileName}${extension}`;
};

const downloadBlob = (blob, fileName) => {
    const tempLink = document.createElement('a');
    tempLink.href = window.URL.createObjectURL(blob);
    tempLink.setAttribute('download', fileName);
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
};

export function onDownloadProgress(cb) {
    if (typeof cb !== 'function') {
        return;
    }
    // eslint-disable-next-line consistent-return
    return (progressEvent) => {
        cb({
            bytesLoaded: progressEvent.loaded,
            bytesTotal: progressEvent.total,
            percent: Math.round((progressEvent.loaded / progressEvent.total) * 100),
        }, progressEvent);
    };
}

const download = ({
 url, params, fileName: backupFileName, onProgress,
}) => new Promise((resolve, reject) => { // Writing the following using async/await did not allow sufficient error handling to test effectively
    if (!backupFileName || typeof backupFileName !== 'string') {
        return reject(Error('fileName must be provided as a string'));
    } else if (!url || typeof url !== 'string') {
        return reject(Error('url must be provided as a string'));
    }
    return HTTP({
        method: 'get',
        responseType: 'blob',
        params,
        url,
        onDownloadProgress: onDownloadProgress(onProgress),
    }).then(({ data, headers }) => {
        const blob = new Blob([data]);
        const fileName = determineFileName(headers) || determineMimeType({ backupFileName, mimeType: data.type });
        downloadBlob(blob, fileName);
        return resolve();
    }).catch(error => reject(error));
});

export default download;
